import { apiClient } from '@utils';

export const useSimulatorStatuses = (batchId: string) => {
  const result = apiClient.customsSimulator.getBatchCustomsSimulatorStatuses.useQuery(
    ['simulator-statuses', batchId],
    {
      params: { batchId },
    },
    {
      enabled: !!batchId,
      queryKey: ['simulator-statuses', batchId],
      // onError: (error) => {
      //   showErrorToast(error, 'Failed to fetch simulator statuses');
      // },
    },
  );

  return { ...result, data: result.data?.body?.statuses || [] };
};
